import { useEffect } from 'react';

const SITE = 'https://skyeai.io';
const DEFAULT_IMAGE = SITE + '/skye-logo-hero.png';
const DEFAULT_DESC = 'Skye AI builds custom AI systems for businesses — voice agents, chatbots, follow-up automation, and workflow buildouts. Done for you, managed by our team.';

function setMeta(name, content, attr) {
  const selector = attr === 'property' ? `meta[property="${name}"]` : `meta[name="${name}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr || 'name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default function SEO({ title, description, path, keywords, type, schema }) {
  useEffect(() => {
    const fullTitle = title ? title + ' | Skye AI' : 'Skye AI - The AI That Sells For You';
    const url = SITE + (path || '/');
    const desc = description || DEFAULT_DESC;
    const kw = keywords || 'Skye AI, AI revenue engine, AI sales automation, AI for business';

    // Title
    document.title = fullTitle;

    // Basic meta
    setMeta('description', desc);
    setMeta('keywords', kw);
    setLink('canonical', url);

    // Open Graph
    setMeta('og:type', type || 'website', 'property');
    setMeta('og:url', url, 'property');
    setMeta('og:title', fullTitle, 'property');
    setMeta('og:description', desc, 'property');
    setMeta('og:image', DEFAULT_IMAGE, 'property');
    setMeta('og:site_name', 'Skye AI', 'property');

    // Twitter
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:url', url);
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', desc);
    setMeta('twitter:image', DEFAULT_IMAGE);

    // JSON-LD
    if (schema) {
      const id = 'seo-jsonld';
      let script = document.getElementById(id);
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
      return () => { if (script.parentNode) script.parentNode.removeChild(script); };
    }
  }, [title, description, path, keywords, type, schema]);

  return null;
}
